// AISC GR §5.7 finding class taxonomy + GR §6.2 CAR response API extensions
// GAP-017+18+19 closure
import ApiCall from "./apicall";

export const FINDING_CLASSES = [
  { value: "IDENTIFIED_STRENGTH", label: "Identified Strength", color: "success" },
  { value: "OFI", label: "Opportunity for Improvement", color: "info" },
  { value: "ARA", label: "Area Requiring Action", color: "warning" },
  { value: "ANC", label: "Audit Nonconformance", color: "warning" },
  { value: "CAR", label: "Corrective Action Request", color: "error" },
];

export const FINDING_CLASS_LABELS = Object.fromEntries(
  FINDING_CLASSES.map((c) => [c.value, c.label])
);
export const FINDING_CLASS_COLORS = Object.fromEntries(
  FINDING_CLASSES.map((c) => [c.value, c.color])
);

export const carApi = {
  // GR §6.2 — submit 5-field structured CAR response
  submitResponse: (ncrId, payload) =>
    ApiCall.post(`/ncrs/${ncrId}/car-response`, payload),

  // GR §5.8 — fetch potential repetitive parents
  potentialRepetitive: (ncrId) =>
    ApiCall.get(`/ncrs/${ncrId}/potential-repetitive`),

  // Mark this CAR as repetitive of parent
  setRepetitive: (ncrId, parentId) =>
    ApiCall.post(`/ncrs/${ncrId}/repetitive`, { repetitive_of_id: parentId }),
};

export function daysUntilDeadline(deadline_at) {
  if (!deadline_at) return null;
  const d = new Date(deadline_at);
  const now = new Date();
  return Math.floor((d.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
}
